export default {
  /* For API's Endpoints */

  BASEURL: "https://finance.enkart.in/api/",
  //BASEURL: "http://localhost:1212",

  /* For Auth API's Endpoints */

  LOGIN: "/auth/login",
  VERIFYOTP: "/auth/verifyotp",
  LOGOUT: "/auth/logout",

  /* For Vehicle Accounts API's Endpoints */

  GETVEHICLEACCOUNT: "/vehAcc/getcabreports",
  CREATEPAYMENTHISTORY: "/vehAcc/addVehPayment",
  CREATEPAIDPAYMENT: "/vehAcc/addVehPaymentHis",
  UPDATETTOPAY: "/vehAcc/toPayCal",
  SENDPDF: "/vehAcc/vehiclePerformance",

  /* For Payment Report API's Endpoints */

  VEHICALEHISTORY: "/vehAcc/getVehPaymentHis",
  UPDATEHISTORY: "/vehAcc/editVehPaymentHis",

  /* For Corporate Trip API's Endpoints */

  GETCORPORATETRIP: "/corpTrips/getcorptripreport",

  /* For Prepaid Trip API's Endpoints */

  PREPAIDTRIP: "/corpTrips/getprepaidreport",

  /* For Driver Attendance API's Endpoints */

  GETDRIVERATTEN: "/vehAcc/getdriverattandance",
  GETBLOCKDRIVERATTEN: "/vehAcc/getblockdriverattandance",
  BLOCKEDCAB: "/vehAcc/blockorUnblockcab",
  // ACTIVECAB: "/vehAcc/unblockcab",

  /* For Booking Report API's Endpoints */

  GETBOOKINGREPORT: "/vehAcc/getbookingreport",
  GETCOMPANY: "/vehAcc/getcompanieslist",
  UPDATECOMPANY: "/vehAcc/manualinvoicegst",
  UPDATEPREPAID: "/vehAcc/editprepaidstatus",

  /* For Enterprises API's Endpoints */

  FETCHCORPORATE: "/corpTrips/getCompanyList",
  ADDCORPORATE: "/corpTrips/addCompany",
  GETCOMPANYID: "/corpTrips/getCompanyID",
  EDITCORPORATE: "/corpTrips/editCompany",

  /* For Driver Details API's Endpoints */

  GETDRIVER: "/vehAcc/getdriverdetails",

  /* For Owner Details API's Endpoints */

  GETOWNER: "/vehAcc/getownerdetails",

  /* For Status Report API's Endpoints */

  GETSTATUSREPORT: "/vehAcc/getBlockLogs",

  /* For Vehicle Master API's Endpoints */

  GETVEHICLEMASTER: "/vehAcc/vehAccStatement",
  UPDATEDATA: "/vehAcc/paidtoowner",

  /* For Driver Calls API's Endpoints */
  GETDRIVERCALL: "/vehAcc/getdrivercalls",
  GETCALLTIME: "/vehAcc/summarydrivercalls",
  ADDDRIVERCALL: "/vehAcc/adddrivercall",
};
